import React from 'react';
import { SymptomChip } from './SymptomChip';
import { symptomGroups, symptoms } from '../../data/symptoms';
import { SymptomGroupId } from '../../types/content';
interface SymptomFieldProps {
  selected: string[];
  onToggle: (id: string) => void;
  /** Limit to a subset of groups — the home teaser shows fewer. */
  groups?: SymptomGroupId[];
}
export function SymptomField({
  selected,
  onToggle,
  groups
}: SymptomFieldProps) {
  const visibleGroups = groups ? symptomGroups.filter(group => groups.includes(group.id)) : symptomGroups;
  return <div className="flex flex-col gap-10" data-id="element-107" data-mp="1l75gvsmnpx3r">
      {visibleGroups.map(group => <fieldset key={group.id} data-id="element-108" data-mp="1gcssd46bpvl5">
          <legend className="text-[0.6875rem] uppercase tracking-label text-brick" data-id="element-109" data-mp="1ccqqatwof05c">
            {group.label}
          </legend>
          <p className="mt-2 text-sm text-ink-soft" data-id="element-110" data-mp="28uwr8qon002e">{group.note}</p>
          <div className="mt-5 flex flex-wrap gap-2.5" data-id="element-111" data-mp="243ya5ovtqxy3">
            {symptoms.filter(symptom => symptom.group === group.id).map(symptom => <SymptomChip key={symptom.id} label={symptom.label} selected={selected.includes(symptom.id)} onToggle={() => onToggle(symptom.id)} data-id="element-112" data-mp="30vko6wz8rgku" />)}
          </div>
        </fieldset>)}
    </div>;
}